import React from 'react';
import './FinancasWaitingBadge.css';
import { FinancasWaitingData } from './types';

interface Props {
  waiting?: FinancasWaitingData | null;
}

/**
 * Marks a case where the Autoridade Tributária is waiting on the lawyer.
 *
 * The reader opens each e-balcão request and records whether the last message
 * asks her for something. That is the one fact she cannot see without logging
 * into the portal and opening the thread, so it belongs on the row: the point
 * is spotting the cases that need her without opening any of them.
 *
 * Renders nothing otherwise, including when the request was read and nothing
 * is being asked. A badge on every row would say nothing.
 */
const FinancasWaitingBadge: React.FC<Props> = ({ waiting }) => {
  if (!waiting?.awaiting_lawyer) {
    return null;
  }
  const askedFor = waiting.asked_for?.trim();
  return (
    <span
      className="case-financas-waiting-badge"
      data-testid="case-financas-waiting-badge"
      title={
        askedFor
          ? `Finanças asked: ${askedFor}`
          : 'The last message in the e-balcão request asks us for something.'
      }
    >
      Finanças asked
    </span>
  );
};

export default FinancasWaitingBadge;
